import { baseUrl } from "../../../config/url-config/index";
import axiosInstance from "../axiosInstance";

const Post = async (path, data) => {
  try {
    const result = await axiosInstance.post(`${baseUrl}/${path}`, data);
    return result;
  } catch (err) {
    throw err;
  }
};

export default Post;
